const DEFAULT_REFRESH_LEAD_TIME_MS = 60_000;

export const resolveAccessTokenRefreshDelay = (
  expiresAtValue: string | number | null | undefined,
  now: number = Date.now(),
  leadTimeMs: number = DEFAULT_REFRESH_LEAD_TIME_MS,
): number | null => {
  if (expiresAtValue === null || expiresAtValue === undefined || expiresAtValue === '') {
    return null;
  }

  const expiresAt = typeof expiresAtValue === 'number'
    ? expiresAtValue
    : Number(expiresAtValue);

  if (!Number.isFinite(expiresAt) || expiresAt <= 0) {
    return null;
  }

  return Math.max(expiresAt - now - Math.max(leadTimeMs, 0), 0);
};
